<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <div>
            <span
              class="text-[20px] leading-[24.2px] text-[#353535] font-semibols mb-[24px]"
            >
              Viewing
            </span>
            <span v-for="(item, index) in Inventories" :key="item.id || index">
              <span
                v-if="index === 0 && item && item.product && item.product.name"
                class="text-[20px] leading-[24.2px] text-[#353535] font-semibols mb-[24px]"
              >
                {{ item.product.name }}
              </span>
            </span>
          </div>

          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="bg-white py-[32px] px-[24px] rounded-[4px] mt-[16px]">
          <div
            class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]"
          >
            <div>
              <h3 class="text-[20px] leading-[20px] text-[#2463EB] font-bold">
                {{ Inventories.length }} Inventory items
              </h3>
            </div>
          </div>
          <div class="w-full">
            <div
              v-for="(item, index) in Inventories"
              :key="item.id || index"
              :class="{
                'w-full border-b': index !== Inventories.length - 1,
                'w-full': index === Inventories.length - 1,
              }"
            >
              <div
                class="flex justify-between items-center gap-[24px] max-w-[500px] w-full py-[16px]"
              >
                <div
                  class="flex items-center gap-[14.45px] cursor-pointer"
                  @click="toggleDetails(index)"
                >
                  <i
                    class="text-[#292D32]"
                    :class="{
                      'fa-solid fa-chevron-up': activeIndex === index,
                      'fa-solid fa-chevron-down': activeIndex !== index,
                    }"
                  ></i>
                  <p
                    class="text-[14px] text-[#353535] leading-[20px] font-bold"
                  >
                    {{ item.product.name }}
                  </p>
                </div>
                <div class="flex gap-[100px]">
                  <span
                    v-if="item.subLocation.location.parentId == user.parentId"
                    @click.prevent="viewEdit(item)"
                    class="text-[#96A0B5] text-[14px] font-normal leading-[20px] cursor-pointer"
                  >
                    Edit
                  </span>
                  <span
                    v-if="hasPermission('Inventory_Delete')"
                    @click.prevent="confirmDelete(item.id)"
                    class="text-[#DC2828] text-[14px] font-normal leading-[20px] cursor-pointer"
                  >
                    Delete
                  </span>
                </div>
              </div>

              <!-- Details Section -->
              <div v-if="activeIndex === index" class="py-[16px] border-t">
                <ul class="pl-[48px]">
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Product Name
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ item.product.name }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Product Code
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ item.product.code }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Unit
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ item.product ? item.product.unit : "N/A" }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Warehouse
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{
                          item.subLocation
                            ? item.subLocation.location.name
                            : "N/A"
                        }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Storage Area
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{
                          item.subLocation
                            ? item.subLocation.location.state
                            : "N/A"
                        }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Cost Per item
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ item.costPerItem }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Initial Quantity
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ formatNumber(item.initialQuantity) }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Quantity Left
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ item.quantity }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Receipt Date
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ formatDateWithTime(item.receiptDate) }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Expiry Date
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ formatDateWithTime(item.expiryDate) }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Product Batch ID
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{
                          item.productBatchId ? item.productBatchId : "N/A"
                        }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-[16px]"
                    >
                      <h2
                        class="font-normal text-[16px] text-[#96a0b5] md:max-w-[250px] w-full"
                      >
                        Date Created
                      </h2>
                      <span
                        class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                      >
                        {{ formatDateWithTime(item.created) }}</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="mod-edit" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Edit Stock
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="p-0 m-0">
            <div v-if="inventoryEditType === 'product'" class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="updateInventories.productId"
                  :disabled="!hasPermission('Inventory_Adjust_Stock')"
                >
                  <option v-for="loc in Products" :key="loc.id" :value="loc.id">
                    {{ loc.name }} - {{ loc.unit }}
                  </option>
                </select>
                <ul v-if="v2.productId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div
              v-if="inventoryEditType === 'product-bundle'"
              class="pb-[16px]"
            >
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product Bundle</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="updateInventories.productId"
                  :disabled="!hasPermission('Inventory_Adjust_Stock')"
                >
                  <option
                    v-for="loc in ProductBundles"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }} - {{ loc.unit }}
                  </option>
                </select>
                <ul v-if="v2.productId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehousess</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  id="location_select"
                  placeholder="Select an option"
                  v-model="updateInventories.subLocation.locationId"
                  :disabled="!hasPermission('Inventory_Adjust_Stock')"
                >
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v2.locationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Storage Area</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  id="sublocation_select"
                  placeholder="Select an option"
                  v-model="updateInventories.subLocationId"
                  :disabled="!hasPermission('Inventory_Adjust_Stock')"
                >
                  <option
                    v-for="loc in SubLocationsForUpdate"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v2.subLocationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Cost Per Item</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.costPerItem }]"
                  type="number"
                  v-model="updateInventories.costPerItem"
                />
                <ul v-if="v2.costPerItem" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Quantity</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.quantity }]"
                  type="number"
                  v-model="updateInventories.initialQuantity"
                  :readonly="!hasPermission('Inventory_Adjust_Stock')"
                />
                <ul v-if="v2.quantity" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Inventory Receipt Date</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.receiptDate }]"
                  type="date"
                  placeholder="Select a date"
                  v-model="updateInventories.receiptDate"
                  :readonly="!hasPermission('Inventory_Adjust_Stock')"
                />
                <ul v-if="v2.receiptDate" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Expiry Date</label
              >
              <div>
                <input
                  type="date"
                  :max="maxDate"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.expiryDate }]"
                  placeholder="Select a date"
                  v-model="updateInventories.expiryDate"
                />
                <ul v-if="v2.expiryDate" class="parsley-errors-list filled">
                  <li class="parsley-required">
                    Expiry date must be greater than inventory received date.
                  </li>
                </ul>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Expiry Notification (Days)</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.expiryNotification }]"
                  type="number"
                  v-model="updateInventories.expiryNotification"
                />
                <ul
                  v-if="v2.expiryNotification"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product Batch ID</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.productBatchId }]"
                  v-model="updateInventories.productBatchId"
                />
                <ul v-if="v2.productBatchId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              @click="cancel"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="update"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteStock"
      :isBusy="isBusyModal"
      text="stock"
    />
    <GeneralDeleteMessage
      message="You cannot delete this inventory record because there is a reconcile order transaction history associated with it."
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import GeneralDeleteCaution from "../GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../GeneralDeleteMessage.vue";
import Pagination from "../Pagination.vue";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Inventory from "../../views/inventory.vue";

export default {
  props: ["closeModal", "ProductId"],
  mixins: [SystemPermissions.Mixin],
  name: "settingsManageStock",
  components: {
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
  },

  created() {
    if (!this.hasPermission("Inventory_View")) {
      this.$router.push("/restricted");
    }
    this.getLocations();
    this.getSubLocations();
    this.getProducts();
    this.getProductBundles();
    this.getSystemSettings();
  },

  watch: {
    updateInventories: {
      deep: true,
      immediate: true,

      handler() {
        let filterLocation = this.updateInventories.subLocation.locationId;
        if (filterLocation && filterLocation.length > 0) {
          this.SubLocationsForUpdate = this.SubLocations;
          var newList = this.SubLocationsForUpdate.filter(function(item) {
            let filtered = true;
            if (filterLocation && filterLocation.length > 0) {
              filtered = item.locationId == filterLocation;
            }
            return filtered;
          });
          this.SubLocationsForUpdate = newList;
        }
      },
    },
  },

  data() {
    return {
      activeIndex: null,
      filter: {
        status: "0",
        locationId: "0",
        subLocationId: "0",
        qry: "",
        Selectedoption: "0",
        showForMe: false,
      },
      isBusy: false,
      isBusyModal: false,
      createInventories: {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      },
      updateInventories: {
        costPerItem: null,
        sellPrice: 0,
        initialQuantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
        id: null,
        subLocation: {
          locationId: null,
        },
      },
      editInventories: {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
        id: null,
        subLocation: {
          locationId: null,
        },
      },
      v1: {
        costPerItem: null,
        sellPrice: null,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      },
      v2: {
        costPerItem: null,
        sellPrice: null,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      },
      Inventories: [],
      Locations: [],
      DeleteId: "",
      SubLocations: [],
      SubLocationsForUpdate: [],
      Products: [],
      ProductBundles: [],
      systemSettings: {},
      pageCount: 0,
      count: 0,
      page: 1,
      pageSize: 10,
      hasNext: false,
      hasPrev: false,
      maxDate: "",
      inventoryCreateType: "",
      inventoryEditType: "",
      theProductId: "",
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },

    computed_sublocations_create: function() {
      let filterLocation = this.createInventories.locationId;
      let subLocations = this.SubLocations;
      if (filterLocation && filterLocation.length > 0) {
        return this.SubLocations.filter(function(item) {
          let filtered = true;
          if (filterLocation && filterLocation.length > 0) {
            filtered = item.locationId == filterLocation;
          }
          return filtered;
        });
      }
    },

    computed_sublocations_update: function() {
      let filterLocation = this.updateInventories.subLocation.locationId;
      let subLocations = this.SubLocationsForUpdate;
      if (filterLocation && filterLocation.length > 0) {
        return this.SubLocationsForUpdate.filter(function(item) {
          let filtered = true;
          if (filterLocation && filterLocation.length > 0) {
            filtered = item.locationId == filterLocation;
          }
          return filtered;
        });
      }
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
    this.getInventories();
  },
  methods: {
    toggleDetails(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    async getInventories() {
      try {
        this.isBusy = true;

        const response = await this.$http.get(
          `/Inventories/getInventoryListByProductIdNoPaging?productId=${this.ProductId}`
        );
        const inventories = response.data;
        this.Inventories = inventories;
      } catch (error) {
        console.error("Error fetching inventories:", error);
      } finally {
        $("#mod-filter").modal("hide");
        this.isBusy = false;
      }
    },
    reset() {
      this.filter = {
        subLocationId: "0",
        locationId: "0",
        qry: "",
        Selectedoption: "0",
        showForMe: false,
      };
    },

    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteStock() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(`/Inventories/${this.DeleteId}`);
        if (res.ok) {
          this.$toast.success("Stock deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getInventories();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    cancel() {
      const currentStock = this.Inventories.find(
        (p) => p.id === this.editInventories.id
      );
      (currentStock.costPerItem = this.editInventories.costPerItem),
        (currentStock.sellPrice = this.editInventories.sellPrice),
        (currentStock.quantity = this.editInventories.quantity),
        (currentStock.receiptDate = this.editInventories.receiptDate),
        (currentStock.id = this.editInventories.id),
        (currentStock.productId = this.editInventories.productId),
        (currentStock.subLocation.locationId = this.editInventories.locationId),
        (currentStock.subLocationId = this.editInventories.subLocationId),
        (currentStock.expiryDate = this.editInventories.expiryDate),
        (currentStock.productBatchId = this.editInventories.productBatchId),
        (currentStock.expiryNotification = this.editInventories.expiryNotification);
      $("#mod-edit").modal("hide");
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },

    viewCreate() {
      this.inventoryCreateType = "";
      $("#mod-pre-add").modal("show");
    },

    viewAdd() {
      $("#mod-pre-add").modal("hide");
      this.createInventories = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        receiptDate: moment().format("YYYY-MM-DD"),
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      };
      this.v1 = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      };
      this.createInventories.expiryNotification = this.systemSettings.defaultProductExpiryNotification;
      $("#mod-add").modal("show");
    },

    viewEdit(c) {
      var editValues = {
        costPerItem: c.costPerItem,
        sellPrice: c.sellPrice,
        quantity: c.initialQuantity,
        receiptDate: c.receiptDate,
        productId: c.product.id,
        locationId: c.subLocation.location.id,
        subLocationId: c.subLocation.id,
        id: c.id,
        expiryDate: c.expiryDate,
        productBatchId: c.productBatchId,
        expiryNotification: c.expiryNotification,
      };

      this.editInventories = editValues;
      if (c.product.isBundle) {
        this.inventoryEditType = "product-bundle";
      } else {
        this.inventoryEditType = "product";
      }
      this.updateInventories = c;
      this.updateInventories.receiptDate = moment(String(c.receiptDate)).format(
        "YYYY-MM-DD"
      );

      this.updateInventories.expiryDate = c.expiryDate
        ? moment(String(c.expiryDate)).format("YYYY-MM-DD")
        : "";

      if (!this.updateInventories.expiryNotification) {
        this.updateInventories.expiryNotification = this.systemSettings.defaultProductExpiryNotification;
      }
      $("#mod-edit").modal("show");
    },

    viewFilter() {
      this.page = 0;
      $("#mod-filter").modal("show");
    },

    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        costPerItem: this.createInventories.costPerItem,
        sellPrice: 0, //this.createInventories.sellPrice,
        quantity: this.createInventories.quantity,
        ...(this.inventoryCreateType == "product" && {
          parentId: this.user.parentId,
        }),
        // parentId: this.user.parentId,
        subLocationId: this.createInventories.subLocationId,
        ...(this.inventoryCreateType == "product" && {
          productId: this.createInventories.productId,
        }),
        ...(this.inventoryCreateType == "product-bundle" && {
          productId: this.createInventories.productBundleId,
        }),
        ...(this.inventoryCreateType == "product-bundle" && {
          hasSerialization: false,
        }),
        // productId: this.createInventories.productId,
        receiptDate: this.createInventories.receiptDate,
        expiryDate: this.createInventories.expiryDate,
        productBatchId: this.createInventories.productBatchId,
        expiryNotification: this.createInventories.expiryNotification,
      };

      if (this.validateCreate()) {
        $("#mod-add").modal("hide");

        if (this.inventoryCreateType === "product") {
          await this.$http
            .post("/Inventories/create", data)
            .then(function(res) {
              this.isBusyModal = false;
              this.inventoryCreateType = "";
              this.$toast.success("Inventory created successfully", {
                icon: false,
                rtl: false,
              });
            })
            .catch(function() {});
        } else {
          await this.$http
            .post("/Inventories/createBundle", data)
            .then(function(res) {
              this.isBusyModal = false;
              this.inventoryCreateType = "";
              this.$toast.success("Inventory created successfully", {
                icon: false,
                rtl: false,
              });
            })
            .catch(function() {});
        }

        this.getInventories();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateCreate() {
      this.v1 = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      };
      var isValid = true;

      if (!this.createInventories.costPerItem) {
        this.v1.costPerItem = true;
        isValid = false;
      }

      if (!this.createInventories.quantity) {
        this.v1.quantity = true;
        isValid = false;
      }

      if (!this.createInventories.locationId) {
        this.v1.locationId = true;
        isValid = false;
      }

      if (!this.createInventories.subLocationId) {
        this.v1.subLocationId = true;
        isValid = false;
      }

      if (
        !this.createInventories.productId &&
        this.inventoryCreateType === "product"
      ) {
        this.v1.productId = true;
        isValid = false;
      }

      if (
        !this.createInventories.productBundleId &&
        this.inventoryCreateType === "product-bundle"
      ) {
        this.v1.productBundleId = true;
        isValid = false;
      }

      if (!this.createInventories.receiptDate) {
        this.v1.receiptDate = true;
        isValid = false;
      } else {
        if (this.createInventories.expiryDate) {
          var receivedDate = moment(
            String(this.createInventories.receiptDate)
          ).format("YYYY-MM-DD");
          var expiryDate = moment(
            String(this.createInventories.expiryDate)
          ).format("YYYY-MM-DD");
          if (expiryDate <= receivedDate) {
            this.v1.expiryDate = true;
            isValid = false;
          }
        }
      }

      return isValid;
    },

    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        costPerItem: this.updateInventories.costPerItem,
        sellPrice: 0, //this.updateInventories.sellPrice,
        quantity: this.updateInventories.initialQuantity,
        id: this.updateInventories.id,
        locationId: this.updateInventories.subLocation.locationId,
        subLocationId: this.updateInventories.subLocationId,
        // ...((this.inventoryCreateType == "product" ) && {productId: this.updateInventories.productId}),
        // ...((this.inventoryCreateType == "product-bundle" ) && {productId: this.updateInventories.productBundleId}),
        ...(this.inventoryEditType == "product-bundle" && {
          hasSerialization: false,
        }),
        productId: this.updateInventories.productId,
        receiptDate: this.updateInventories.receiptDate,
        expiryDate: this.updateInventories.expiryDate,
        productBatchId: this.updateInventories.productBatchId,
        expiryNotification: this.updateInventories.expiryNotification,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .put("/Inventories/update/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            if (this.$route.params.id) this.$router.push("/managestock");
          })
          .catch(function() {});

        this.getInventories();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateUpdate() {
      this.v2 = {
        costPerItem: null,
        sellPrice: 0,
        quantity: null,
        locationId: null,
        subLocationId: null,
        productId: null,
        productBundleId: null,
        receiptDate: null,
        expiryDate: null,
        productBatchId: null,
        expiryNotification: null,
      };
      var isValid = true;

      if (!this.updateInventories.costPerItem) {
        this.v2.costPerItem = true;
        isValid = false;
      }

      if (!this.updateInventories.initialQuantity) {
        this.v2.quantity = true;
        isValid = false;
      }

      if (!this.updateInventories.subLocation.locationId) {
        this.v2.locationId = true;
        isValid = false;
      }

      if (!this.updateInventories.subLocationId) {
        this.v2.subLocationId = true;
        isValid = false;
      }

      if (
        !this.updateInventories.productId &&
        this.inventoryCreateType === "product"
      ) {
        this.v2.productId = true;
        isValid = false;
      }

      if (!this.updateInventories.receiptDate) {
        this.v2.receiptDate = true;
        isValid = false;
      } else {
        if (this.updateInventories.expiryDate) {
          var receivedDate = moment(
            String(this.updateInventories.receiptDate)
          ).format("YYYY-MM-DD");
          var expiryDate = moment(
            String(this.updateInventories.expiryDate)
          ).format("YYYY-MM-DD");
          if (expiryDate <= receivedDate) {
            this.v2.expiryDate = true;
            isValid = false;
          }
        }
      }

      return isValid;
    },

    getLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/Locations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Locations = res.body;
        })
        .catch(function() {});
    },
    getSubLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/SubLocations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId +
            "&locationId="
        )
        .then(function(res) {
          this.SubLocations = res.body;
          this.SubLocationsForUpdate = res.body;
        })
        .catch(function() {});
    },
    getProducts() {
      var a = true;

      this.$http
        .get(
          "/Products/getListNoPagingForDistributor?active=" +
            a +
            "&parentId=" +
            this.user.parentId +
            "&excludeProductBundle=" +
            a
        )
        .then(function(res) {
          this.Products = res.body;
        })
        .catch(function() {});
    },

    getProductBundles() {
      this.$http
        .get("/ProductBundle/getList")
        .then(function(res) {
          this.ProductBundles = res.body;
        })
        .catch(function() {});
    },

    async getSystemSettings() {
      this.isBusy = true;

      await this.$http
        .get(
          "/SystemSettings/getList?page=0" +
            "&pageSize=10" +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.systemSettings = res.body.data[0];
          this.isBusy = false;
        })
        .catch(function() {});

      this.isBusy = false;
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatDateWithTime(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    prev() {
      this.page -= 1;
      this.getInventories();
    },
    next() {
      this.page += 1;
      this.getInventories();
    },
    gotoPage(page) {
      this.page = page;
      this.getInventories();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getInventories();
    },
  },
};
</script>

<style></style>
